/**
 * Adds a transition for the element from closed to open.
 * @param {Element} element
 */
export const expandDrawer = element => {
  const el = element;
  const sectionHeight = el.scrollHeight;

  el.style.height = `${sectionHeight}px`;
};

/**
 * Adds a transition for the element from open to closed.
 * @param {Element} element
 */
export const collapseDrawer = element => {
  const el = element;
  const sectionHeight = el.scrollHeight;

  const elementTransition = el.style.transition;
  el.style.transition = '';

  requestAnimationFrame(() => {
    el.style.height = `${sectionHeight}px`;
    el.style.transition = elementTransition;

    requestAnimationFrame(() => {
      el.style.height = '0';
    });
  });
};
